import { Component, Inject } from '@angular/core';
import { CommonModule } from '@angular/common';
import { FormsModule } from '@angular/forms';
import { MAT_DIALOG_DATA, MatDialogRef } from '@angular/material/dialog';

import { AdvanceSearchService } from '../../../services/Advance-search/advance-search.service';
import { ToastService } from '../../../services/toast/toast.service';

@Component({
  selector: 'app-manual-edit-name',
  standalone: true,
  imports: [CommonModule, FormsModule],
  templateUrl: './manual-edit-name.component.html',
  styleUrl: './manual-edit-name.component.scss'
})
export class ManualEditNameComponent {

  firstName: string = '';
  middleName: string = '';
  lastName: string = '';

  errorMessage: string = '';

  constructor(
    @Inject(MAT_DIALOG_DATA) public data: any,
    private dialogRef: MatDialogRef<ManualEditNameComponent>,
    private advanceSearch: AdvanceSearchService,
    private toaster: ToastService,
  ) {

    this.firstName =
      data?.devoteeDetails?.devoteeFirstName ||
      data?.devoteeFirstName ||
      '';

    this.middleName =
      data?.devoteeDetails?.devoteeMiddleName ||
      data?.devoteeMiddleName ||
      '';

    this.lastName =
      data?.devoteeDetails?.devoteeLastName ||
      data?.devoteeLastName ||
      '';
  }

  close(): void {
    this.dialogRef.close();
  }

  continue(): void {

    const payLoad = {
      familyCode:
        this.data.editType !== 'Visitor'
          ? this.data.devoteeDetails.devoteeFamilyCode
          : this.data.familyCode,

      devoteeId:
        this.data.editType !== 'Visitor'
          ? this.data.devoteeDetails.devoteeId
          : null,

      devoteeFirstName: this.firstName,
      devoteeMiddleName: this.middleName,
      devoteeLastName: this.lastName
    };

    this.advanceSearch.UpdateManualName(payLoad).subscribe({

      next: (res: any) => {

        this.toaster.success(
          `${this.data.editType === 'Visitor'
            ? 'Visitor'
            : 'Devotee'} name successfully updated`
        );

        this.dialogRef.close(true);
      },

      error: (err: any) => {

        this.errorMessage =
          err?.error?.message || 'Something went wrong';

        this.toaster.error(this.errorMessage);
      }
    });
  }
}